import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import navbar from './navbar'
import auth from './auth'
import loader from './loader'
import product from './product'
import devices from './devices'
import general from './general'
import asset from './asset'
import customer from './customer'
import facility from './facility'
import deviceData from './deviceData'

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    navbar,
    auth,
    customer,
    facility,
    loader,
    product,
    devices,
    general,
    asset,
    deviceData,
  })
